import api from '../../models/KanbanAdjustUpload'
import swal from 'sweetalert2'
import moment from 'moment'
export default {
  name: 'KanbanAdjustDayoffUpload',
  components: {},
  data() {
    return {
      // upload kba
      is_load: true,
      is_upload_error: true,
      kba_temp: [],
      kba_temp_status: {
        all: 0,
        success: 0,
        error: 0
      },
      // set cycle
      spl_id: 0,
      spl_list: [],
      dk_id: 0,
      dock_list: [],
      spl_plant_code: '',
      date_1: null,
      cdcl_1: 0,
      date_2: null,
      cdcl_2: 0,
      date_3: null,
      cdcl_3: 0,
      cycle_list_2: [],
      cycle_list_3: [],
      cycle_list_kba: [],
      // modal
      kbalt_modal: false,
      kbalt_data: []
    }
  },
  created() {
    this.checkOAuth()
    this.getKbaTempList()
  },
  mounted() {
    $('#select2-dock').select2({
      placeholder: '- Select Dock -',
      allowClear: true,
      dropdownPosition: 'below'
    })
    $('#select2-dock').on('select2:select', e => {
      this.changeDock($('#select2-dock').val())
    })
    $('#select2-dock').on('select2:clear', e => {
      this.changeDock('0')
    })
    $('#select2-supplier').select2({
      placeholder: '- Select Supplier -',
      allowClear: true,
      dropdownPosition: 'below'
    })
    $('#select2-supplier').on('select2:select', e => {
      this.changeSupplier($('#select2-supplier').val())
    })
    $('#select2-supplier').on('select2:clear', e => {
      this.changeSupplier('0')
    })
  },
  methods: {
    goBack() {
      this.$router.push({
        name: 'KanbanAdjust',
        params: {
          active_page: typeof this.$route.params.active_page !== 'undefined' ? this.$route.params.active_page : 1,
          dock: typeof this.$route.params.dock !== 'undefined' ? this.$route.params.dock : '',
          supplier: typeof this.$route.params.supplier !== 'undefined' ? this.$route.params.supplier : '',
          part: typeof this.$route.params.part !== 'undefined' ? this.$route.params.part : '',
          is_active: typeof this.$route.params.is_active !== 'undefined' ? this.$route.params.is_active : ''
        }
      })
    },
    // upload kba
    uploadKba() {
      swal
        .fire({
          title: 'Confirm Upload Adjust',
          text: 'Old adjust data will be deleted.',
          //  icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, Upload now!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            this.is_load = true
            this.kba_temp = []
            let form_data = new FormData()
            let kba_file = document.querySelector('#kba_file')
            form_data.append('kba_file', kba_file.files[0])
            this.is_load = true
            api.uploadKba(
              this.$store.state.URLHost,
              form_data,
              this.header,
              result => {
                this.is_load = false
                this.getKbaTempList()
                this.$refs.kba_file.value = null
                if (result.is_error === 0) {
                  this.alertUploadKba('success', result.message)
                } else {
                  let message = ''
                  let spl_message = result.message.split('|')
                  for (let item of spl_message) {
                    message = message + '- ' + item + '<br>'
                  }
                  this.alertUploadKba('error', message)
                }
              },
              error => {
                this.is_load = false
                this.getKbaTempList()
                this.$refs.kba_file.value = null
                this.alertUploadKba('error', error.message)
              }
            )
          }
        })
    },
    alertUploadKba(type, message) {
      swal.fire({
        title: '<h3 class="card-title">Result Upload Adjust</h3>',
        html: '<p class="text-left">' + message + '</p>',
        showCloseButton: false,
        showCancelButton: false,
        confirmButtonText: 'OK, Close this window.'
      })
    },
    // set cycle
    getKbaTempList() {
      this.is_load = true
      this.dock_list = []
      this.spl_list = []
      this.kba_temp = []
      this.kba_temp_status.all = 0
      this.kba_temp_status.success = 0
      this.kba_temp_status.error = 0
      this.date_1 = null
      this.cdcl_1 = 0
      this.date_2 = null
      this.cdcl_2 = 0
      this.date_3 = null
      this.cdcl_3 = 0
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        spl_plant_code: this.spl_plant_code
      }
      api.getKbaTempList(
        this.$store.state.URLHost,
        this.header,
        result => {
          this.is_load = false
          if (result.response === true) {
            if (result.is_error === 0) {
              this.kba_temp = result.data.kba_temp
              this.date_1 = moment(result.data.date_1).startOf('day')
              this.cdcl_1 = result.data.cdcl_1
              this.dock_list = result.data.dock_list
              this.spl_list = result.data.spl_list
            }
            this.kba_temp_status.all = result.data.kba_temp_status.all
            this.kba_temp_status.success = result.data.kba_temp_status.success
            this.kba_temp_status.error = result.data.kba_temp_status.error
          } else {
            // this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        error => {
          this.is_load = false
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    changeDock(id) {
      this.dk_id = id
      this.clearFilter()
    },
    changeSupplier(id) {
      this.spl_id = id
      this.clearFilter()
    },
    changePlantCode() {
      this.clearFilter()
    },
    clearFilter() {
      this.date_1 = null
      this.cdcl_1 = 0
    },
    setDate2(date, date_string) {
      this.is_load = true
      this.date_2 = date ? date.startOf('day') : null
      this.date_3 = null
      this.cdcl_2 = 0
      this.cdcl_3 = 0
      this.cycle_list_2 = []
      this.cycle_list_3 = []
      this.cycle_list_kba = []
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date: moment(this.date_2).format('YYYY-MM-DD')
      }
      api.getCycleList(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.cycle_list_2 = result.data.cycle_list
          }
          this.is_load = false
        },
        error => {
          this.is_load = false
          console.log(error.message)
        }
      )
    },
    setDate3(date, date_string) {
      this.is_load = true
      this.date_3 = date ? date.startOf('day') : null
      this.cdcl_3 = 0
      this.cycle_list_3 = []
      this.cycle_list_kba = []
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date: moment(this.date_3).format('YYYY-MM-DD')
      }
      api.getCycleList(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.cycle_list_3 = result.data.cycle_list
          }
          this.is_load = false
        },
        error => {
          this.is_load = false
          console.log(error.message)
        }
      )
    },
    setCycle2() {
      this.date_3 = null
      this.cdcl_3 = 0
      this.cycle_list_3 = []
      this.cycle_list_kba = []
    },
    setCycle3() {},
    disabledInputKbaCycleList() {
      if (this.date_1 === null || this.cdcl_1 === 0) {
        return true
      }
      return false
    },
    disabledDate2(current) {
      return current && this.date_1 && current < this.date_1
    },
    disabledDate3(current) {
      return current && this.date_2 && current < this.date_2
    },
    disabledCycle2(cdcl_2) {
      if (moment(this.date_1).isSame(moment(this.date_2))) {
        if (this.cdcl_1 >= cdcl_2) {
          return true
        }
        return false
      }
      return false
    },
    disabledCycle3(cdcl_3) {
      if (moment(this.date_2).isSame(moment(this.date_3))) {
        if (this.cdcl_2 > cdcl_3) {
          return true
        }
        return false
      }
      return false
    },
    getKbaCycleList() {
      this.is_load = true
      this.cycle_list_kba = []
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date_1: moment(this.date_1).format('YYYY-MM-DD'),
        date_2: moment(this.date_2).format('YYYY-MM-DD'),
        date_3: moment(this.date_3).format('YYYY-MM-DD'),
        cdcl_1: this.cdcl_1,
        cdcl_2: this.cdcl_2,
        cdcl_3: this.cdcl_3
      }
      api.getKbaCycleList(
        this.$store.state.URLHost,
        this.header,
        result => {
          this.is_load = false
          if (result.response === true) {
            this.cycle_list_kba = result.data.cycle_list_kba
          } else {
            this.cycle_list_kba = []
          }
        },
        error => {
          this.is_load = false
          console.log(error.message)
        }
      )
    },
    setKbaCycleList() {
      swal
        .fire({
          title: 'Confirm Set Adjust Cycle',
          text: 'You want to set adjust cycle list?',
          //  icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, Set now!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            this.is_load = true
            let form_data = {
              spl_id: this.spl_id,
              dk_id: this.dk_id,
              spl_plant_code: this.spl_plant_code,
              cycle_list_kba: this.cycle_list_kba
            }
            api.setKbaCycleList(
              this.$store.state.URLHost,
              form_data,
              this.header,
              result => {
                this.is_load = false
                this.cycle_list_kba = []
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('danger', 'An error occurred.', result.message)
                }
                this.getKbaTempList()
              },
              error => {
                this.is_load = false
                this.alert_msg('danger', 'An error occurred.', error.message)
              }
            )
          }
        })
    },
    openKbaltModal(kbat_id) {
      this.kbalt_modal = true
      let index = this.kba_temp.findIndex(item => item.kbat_id === kbat_id)
      this.kbalt_data = this.kba_temp[index].list
      setTimeout(() => {
        $('#kbalt_modal').modal('show')
      }, 200)
    },
    closeKbaltModal() {
      $('#kbalt_modal').modal('hide')
      setTimeout(() => {
        this.kbalt_data = []
        this.kbalt_modal = false
      }, 200)
    },
    // create kba
    createKba() {
      swal
        .fire({
          title: 'Confirm Create Adjust',
          text: 'You want to create kanban adjust dayoff ?',
          // icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, Create now!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            this.is_load = true
            let form_data = {
              spl_id: this.spl_id,
              dk_id: this.dk_id,
              spl_plant_code: this.spl_plant_code
            }
            api.createKba(
              this.$store.state.URLHost,
              form_data,
              this.header,
              response => {
                this.is_load = false
                this.getKbaTempList()
                this.alert_msg('success', 'Successful.', response.message)
              },
              error => {
                this.is_load = false
                this.alert_msg('danger', 'An error occurred.', error.message)
              }
            )
          }
        })
    },
    getExample() {
      setTimeout(() => {
        this.$refs.export_form.submit()
      }, 500)
    },
    momentTH(date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/KanbanAdjustDayoffUpload.js